import { render } from "./KaizenItemSearch.vue?vue&type=template&id=15cc9c72&ts=true"
import script from "./KaizenItemSearch.vue?vue&type=script&lang=ts"
export * from "./KaizenItemSearch.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\project\\CDM_QR-Access-Control-System-3\\DoorWebApp_Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__